var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.appConfigIsLoaded ? _c("maNavBar") : _vm._e(),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _vm.stateLoader || !_vm.appConfigIsLoaded
            ? _c("ma-loader")
            : _vm._e(),
        ],
        1
      ),
      _c("ma-notifications"),
      _c(
        "div",
        { staticClass: "app-wrapper" },
        [
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [_vm.appConfigIsLoaded ? _c("router-view") : _vm._e()],
            1
          ),
        ],
        1
      ),
      _c("ma-button-phone"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }